import Vue from "vue";
import EventBus from "../../imports/event-bus";

const determineTier = (state) => {
  let current = null;
  state.countTiers.forEach((tier) => {
    if (state.count <= tier.maximum && state.count >= tier.threshold) {
      current = tier;
    }
  });
  return current;
};

const state = {
  count: null,

  currentTier: null,

  // countTiers: [
  //   {
  //     threshold: 0,
  //     maximum: 124,
  //     title: "starter",
  //     badge: "",
  //   },
  //   {
  //     threshold: 125,
  //     maximum: 249,
  //     title: "bronze",
  //     badge: "",
  //   },
  //   {
  //     threshold: 250,
  //     maximum: 499,
  //     title: "silver",
  //     badge: "",
  //   },
  //   {
  //     threshold: 500,
  //     maximum: 99999999,
  //     title: "gold",
  //     badge: "",
  //   },
  // ],

  countTiers: [
    {
      threshold: 0,
      maximum: 2,
      title: "starter",
      badge: "",
    },
    {
      threshold: 3,
      maximum: 4,
      title: "bronze",
      badge: "",
    },
    {
      threshold: 5,
      maximum: 9,
      title: "silver",
      badge: "",
    },
    {
      threshold: 10,
      maximum: 99999999,
      title: "gold",
      badge: "",
    },
  ],
};

const actions = {
  init: async ({ dispatch }) => {
    dispatch("fetch");
  },

  fetch: async ({ commit }) => {
    const response = await Vue.http.get("/users/created-appointment-count");

    commit("setCount", parseInt(response.body));
    commit("updateCurrentTier");
  },

  getCount: ({ state }) => {
    return state.count;
  },
};

const mutations = {
  setCount(state, count) {
    state.count = parseInt(count);
  },

  updateCurrentTier(state) {
    const oldTier = state.currentTier;

    state.currentTier = determineTier(state);

    if (oldTier && state.currentTier && state.currentTier.threshold > oldTier.threshold) {
      setTimeout(() => {
        EventBus.$emit("new-achievement");
      }, 1000);
    }
  },
};

export default {
  namespaced: true,
  actions,
  state,
  mutations,
};
